import { NavLink } from 'react-router';

import { CLICK_ACTION, SIDEBAR_MENU } from '../../../../../constants/tagManager';
import { INavItemProps } from '../../../../../interfaces/globals';
import TagManagerService from '../../../../../services/gtm/tagManagerService';
import Tooltip from '../../../Tooltip/Tooltip';

const NavItem = ({ to, icon, label, collapsed, badge, disabled = false, sectionId }: INavItemProps) => {
  const itemClass = ['nav-item', collapsed ? 'nav-item--collapsed' : '', disabled ? 'nav-item--disabled' : '']
    .filter(Boolean)
    .join(' ');

  const handleClick = () => {
    if (sectionId) {
      TagManagerService.pushEvent(CLICK_ACTION, SIDEBAR_MENU, { section: sectionId });
    }
  };

  const content = (
    <>
      <span className="nav-item__icon">{icon}</span>
      {!collapsed && (
        <span className="nav-item__label">
          {label}
          {badge !== undefined && badge > 0 && <span className="nav-item__badge">{badge}</span>}
        </span>
      )}
      {collapsed && badge !== undefined && badge > 0 && (
        <span className="nav-item__badge nav-item__badge--collapsed">{badge}</span>
      )}
    </>
  );

  const link = disabled ? (
    <button type="button" className={itemClass} disabled aria-disabled="true">
      {content}
    </button>
  ) : (
    <NavLink
      to={to}
      className={({ isActive }) => [itemClass, isActive ? 'nav-item--active' : ''].filter(Boolean).join(' ')}
      onClick={handleClick}
    >
      {content}
    </NavLink>
  );

  if (collapsed) {
    return (
      <Tooltip content={label} placement="right">
        {link}
      </Tooltip>
    );
  }

  return link;
};

export default NavItem;
